import { render, staticRenderFns } from "./changeTemplate.vue?vue&type=template&id=24b7be37&scoped=true&"
import script from "./changeTemplate.vue?vue&type=script&lang=js&"
export * from "./changeTemplate.vue?vue&type=script&lang=js&"
import style0 from "./changeTemplate.vue?vue&type=style&index=0&id=24b7be37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b7be37",
  null
  
)

export default component.exports